/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringcontainsaspect10Inputs */



/**

* @param {_Filter_Class_Stringcontainsaspect10Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringcontainsaspect10 = /** @type {((inputs?: _Filter_Class_Stringcontainsaspect10Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringcontainsaspect10Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet")
});
export { _filter_class_stringcontainsaspect10 as "_filter_class_StringCONTAINSAspect" }